import createIcon from '../../createIcon';

/**
 * @component @name Grading
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA3SDIwVjlINFY3Wk00IDEzSDIwVjExSDRWMTNaTTQgMTdIMTFWMTVINFYxN1pNNCAyMUgxMVYxOUg0VjIxWk0xNS40MSAxOC4xN0wxNCAxNi43NUwxMi41OSAxOC4xNkwxNS40MSAyMUwyMCAxNi40MkwxOC41OCAxNUwxNS40MSAxOC4xN1pNNCAzVjVIMjBWM0g0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Grading = createIcon('Grading', [
  [
    'path',
    {
      d: 'M4 7H20V9H4V7ZM4 13H20V11H4V13ZM4 17H11V15H4V17ZM4 21H11V19H4V21ZM15.41 18.17L14 16.75L12.59 18.16L15.41 21L20 16.42L18.58 15L15.41 18.17ZM4 3V5H20V3H4Z',
      key: '192m13',
    },
  ],
]);

export default Grading;
